import qs from 'qs'
import request from '@/utils/request'

function toFormData (data = {}) {
  const params = {}
  Object.keys(data).forEach(key => {
    const value = data[key]
    if (value !== undefined && value !== null && value !== '') {
      params[key] = Array.isArray(value) || typeof value === 'object' ? JSON.stringify(value) : value
    }
  })
  return qs.stringify(params)
}

// 报告列表接口暂按后端现有 CRUD 命名约定预留，后端路径确认后只需调整 url。
export function getReportList (data) {
  return request({
    url: '/report/getReportList',
    method: 'post',
    data: toFormData(data)
  })
}

export function getReportDetail (data) {
  return request({
    url: '/report/getReportDetail',
    method: 'post',
    data: toFormData(data)
  })
}

export function addReport (data) {
  return request({
    url: '/report/addReport',
    method: 'post',
    data: toFormData(data)
  })
}

export function updateReport (data) {
  return request({
    url: '/report/updateReport',
    method: 'post',
    data: toFormData(data)
  })
}

export function deleteReport (data) {
  return request({
    url: '/report/deleteReport',
    method: 'post',
    data: toFormData(data)
  })
}

export function normalizePageResponse (res) {
  return {
    list: Array.isArray(res && res.data) ? res.data : [],
    total: Number((res && res.total) || 0),
    raw: res
  }
}
